//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LabCollectionChoiceMixin from '~/mixins/collection-choice/lab-collection-choice'

export default {
  mixins: [LabCollectionChoiceMixin],
  props: {
    page: {
      type: String,
      default: 'science'
    },
    showSubtitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showMapPlaceholder: true,
      optionSelected: null
    }
  },
  computed: {
    tests () {
      return this.$t(`${this.page}.ourTests.tests`)
    }
  },
  methods: {
    onSearchButtonClick () {
      const zipCode = this.getFormFieldParam('zipCode', 'value')
      if (zipCode) {
        this.$root.$emit('bv::show::modal', 'modalMap')
        this.showMapPlaceholder = false
        setTimeout(() => this.searchForNearLab(zipCode), 100)
      }
    },
    selectOption (id, i) {
      if (this.optionSelected === `option-${id}-${i}`) {
        this.optionSelected = null
      } else {
        this.optionSelected = `option-${id}-${i}`
      }
    }
  }
}
